import { Component, Input } from '@angular/core';

@Component({
  selector: 'yoid-spinner',
  templateUrl: './yoid-spinner.component.html'
})
export class YoidSpinnerComponent {
  @Input() message: string = '';
}
